import './bootstrap';
import './alert';
import './responsive';
import './gsap-animations';

import { initPokemonCard } from './pokemon-card.js';

// Import Vue and create app for frontend components (public pages only)
import { createApp } from 'vue';
import SubmissionSteps from './components/SubmissionSteps.vue';

// Card Background System Components
import CardBackground from './components/CardBackground.vue';
import CardConveyor from './components/CardConveyor.vue';
import CardRow from './components/CardRow.vue';
import PokemonCard from './components/PokemonCard.vue';

// Hero Carousel Component (public pages only)
import HeroCarousel from './components/HeroCarousel.vue';

document.addEventListener('DOMContentLoaded', () => {
    initPokemonCard();

    // Initialize Vue components for frontend use
    const submissionStepsElement = document.getElementById('submission-steps-app');
    if (submissionStepsElement) {
        const app = createApp({
            components: {
                SubmissionSteps
            }
        });
        app.mount('#submission-steps-app');
    }

    // Initialize Card Background System
    // This system uses a component architecture for better performance and maintainability
    const cardBackgroundElement = document.getElementById('card-background-app');
    if (cardBackgroundElement) {
        const cardApp = createApp({
            components: {
                CardBackground,
                CardConveyor,
                CardRow,
                PokemonCard
            }
        });

        // Register components globally for the card background app
        cardApp.component('CardConveyor', CardConveyor);
        cardApp.component('CardRow', CardRow);
        cardApp.component('PokemonCard', PokemonCard);

        cardApp.mount('#card-background-app');
    }

    // Initialize Hero Carousel separately
    // This is mounted in the hero-content area
    const heroCarouselElement = document.getElementById('hero-carousel-app');
    if (heroCarouselElement) {
        try {
            const heroApp = createApp({
                components: {
                    HeroCarousel
                },
                errorCaptured(err, instance, info) {
                    // Error captured in HeroCarousel
                    return false; // Prevent error propagation
                }
            });

            // Global error handler for the app
            heroApp.config.errorHandler = (err, instance, info) => {
                // Log error details in development only
                if (process.env.NODE_ENV === 'development') {
                    console.error('HeroCarousel Error:', err);
                }
            };

            // Performance monitoring
            if (window.performance && performance.mark) {
                performance.mark('hero-carousel-start');
            }

            heroApp.component('HeroCarousel', HeroCarousel);
            heroApp.mount('#hero-carousel-app');

            if (window.performance && performance.mark) {
                performance.mark('hero-carousel-end');
                performance.measure('hero-carousel-mount', 'hero-carousel-start', 'hero-carousel-end');
                const measure = performance.getEntriesByName('hero-carousel-mount')[0];
                // Performance: HeroCarousel mounted successfully
            } else {
                // HeroCarousel mounted successfully
            }
        } catch (error) {
            // Failed to mount HeroCarousel, show fallback
            // Show fallback content if mounting fails
            const fallback = heroCarouselElement.querySelector('noscript');
            if (fallback) {
                heroCarouselElement.innerHTML = fallback.innerHTML;
            }
        }
    } else {
        // hero-carousel-app element not found
    }
});
